import { useEffect, useMemo } from "preact/hooks";
import { Breadcrumb } from "~/core";
import { me, useApp } from "~/core/store";
import HomeIcon from "@material-design-icons/svg/outlined/home.svg";

const useBreadcrumbs = (
    parts: Breadcrumb[],
    inputs: ReadonlyArray<unknown> = [],
) => {
    const store = useApp();

    const homeBreadcrumb = useMemo(() => {
        const result = {
            name: "Home",
            content: <HomeIcon className="fill-current" width="20" />,
            link: me("dashboard"),
        };

        const firstPart = parts[0];

        if (firstPart && firstPart.name === "Home") {
            Object.assign(result, firstPart);
        }

        return result;
    }, [parts]);

    const filteredParts = useMemo(
        () => parts.filter((part) => part.name !== "Home"),
        [parts],
    );

    useEffect(() => {
        store.breadcrumbs.items.value = [homeBreadcrumb, ...filteredParts];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
};

export default useBreadcrumbs;
